import { KeyboardArrowDown, KeyboardArrowUp } from '@mui/icons-material';
import { Menu, MenuItem } from '@mui/material';
import React, { Fragment, useState } from 'react';
import { useBreakpoints } from 'v3/hooks/useBreakpoints';
import { LogoutButton } from 'v3/shared/components/Button/LogoutButton';
import { MenuSelectType } from 'v3/shared/components/Menu/types';
import { BodySmallBold } from 'v3/shared/typography/BodySmall';
import { LabelStoreName, PaperProps } from './styles';

export const MenuSelect = ({ userName, StartIcon }: MenuSelectType) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { isDesktop } = useBreakpoints();

  const handleClick = (event: React.MouseEvent<HTMLLabelElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Fragment>
      <LabelStoreName onClick={(event) => handleClick(event)}>
        {StartIcon && <StartIcon />}
        {isDesktop ? (
          <Fragment>
            <BodySmallBold>{userName}</BodySmallBold>
            {open ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </Fragment>
        ) : null}
      </LabelStoreName>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        slotProps={{
          paper: {
            ...PaperProps,
          },
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
      >
        <MenuItem>
          <LogoutButton />
        </MenuItem>
      </Menu>
    </Fragment>
  );
};
